// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"b1bb9f5a","510":"fe2e8c87","813":"0c96be9e","938":"fc2bc1d8"}[chunkId] + ".chunk.css";
};